import React from "react"
import { Link } from "gatsby"
import { RegBody, SemiBdTitle3, SemiBdTitle5 } from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

export interface ProductEntryAdditionalResourceProps {
  additionalResource: boolean
}

const ProductEntryAdditionalResource = ({
  additionalResource,
}: ProductEntryAdditionalResourceProps) => {
  if (!additionalResource) return null

  const resourceArray = [
    {
      title: "Case Studies",
      body: "Learn how our most successful customers solved their communities’ challenges using SmartRent solutions.",
      link: "/case-studies/",
    },
    {
      title: "Reports and Guides",
      body: "In-depth research and analyses of the most current and innovative tech in the rental space.",
      link: "/reports-guides/",
    },
    {
      title: "Blog",
      body: "Read up on the latest trends and best practices in property operations in the multifamily industry.",
      link: "/news/",
    },
  ]

  return (
    <ProductEntryAdditionalResourceStyled>
      <SemiBdTitle3 className="product-entry-additional-resource__header">
        Resource Library
      </SemiBdTitle3>

      <div className="product-entry-additional-resource__resources-container">
        {resourceArray.map((resource: any, i: number) => {
          return (
            <div
              className="product-entry-additional-resource__resource-container"
              key={i}
            >
              <SemiBdTitle5 className="product-entry-additional-resource__resource-title">
                {resource.title}
              </SemiBdTitle5>
              <RegBody className="product-entry-additional-resource__resource-body">
                {resource.body}
              </RegBody>
              <div className="product-entry-additional-resource__resource-link">
                <Link to={resource.link}>Read More</Link>
              </div>
            </div>
          )
        })}
      </div>
    </ProductEntryAdditionalResourceStyled>
  )
}

export default ProductEntryAdditionalResource

const ProductEntryAdditionalResourceStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 100%;
  background-color: var(--color-gray900);
  color: var(--color-white);
  padding: ${rem(40)} ${rem(16)} 0;
  margin-top: ${rem(136)};

  @media ${media.midUp} {
    padding: ${rem(56)} ${rem(64)} ${rem(72)};
    margin-top: ${rem(176)};
  }

  @media ${media.stMidUp} {
    align-items: center;
    justify-content: center;
    padding-top: ${rem(64)};
    margin-top: ${rem(184)};
  }

  .product-entry-additional-resource__header {
    max-width: ${rem(150)};
    font-size: ${rem(32)};
    line-height: ${rem(40)};
    color: var(--color-primary-on-dark);

    @media ${media.midUp} {
      max-width: ${rem(521)};
      font-size: ${rem(40)};
      line-height: ${rem(48)};
    }

    @media ${media.stMidUp} {
    }
  }

  .product-entry-additional-resource__resources-container {
    @media ${media.midUp} {
      max-width: ${rem(472)};
    }

    @media ${media.stMidUp} {
      display: flex;
      max-width: ${rem(977)};
      height: ${rem(224)};
      margin: ${rem(64)} 0 ${rem(56)};
    }
    .product-entry-additional-resource__resource-container {
      border-bottom: ${rem(1)} solid var(--color-gray075);
      padding-top: ${rem(32)};

      @media ${media.stMidUp} {
        border-bottom: none;
        border-right: ${rem(1)} solid var(--color-gray075);
        height: 100%;
        padding: 0 ${rem(72)};
      }
      .product-entry-additional-resource__resource-title {
        @media ${media.midUp} {
          font-size: ${rem(24)};
        }
      }

      .product-entry-additional-resource__resource-body {
        padding-top: ${rem(8)};

        @media ${media.midUp} {
          padding-top: ${rem(16)};
        }

        @media ${media.stMidUp} {
          max-width: ${rem(235)};
        }
      }

      .product-entry-additional-resource__resource-link {
        padding: ${rem(40)} 0 ${rem(32)};
        font-size: ${rem(20)};
        text-decoration: underline;
        text-decoration-color: var(--color-primary-on-dark);

        @media ${media.midUp} {
          padding: ${rem(40)} 0 ${rem(48)};
          font-weight: 600;
        }

        @media ${media.stMidUp} {
          align-self: flex-end;
        }
      }
    }

    .product-entry-additional-resource__resource-container:first-child {
      padding-top: ${rem(40)};

      @media ${media.midUp} {
        padding-top: ${rem(32)};
      }

      @media ${media.stMidUp} {
        padding: 0 ${rem(64)} 0 0;
      }
    }

    .product-entry-additional-resource__resource-container:last-child {
      border-bottom: none;
      padding-bottom: ${rem(24)};

      @media ${media.stMidUp} {
        border-right: none;
        padding: 0 0 0 ${rem(64)};
      }
    }
  }
`
